// extracted by mini-css-extract-plugin
export default {"container":"InsuranceUpload_container__QxbZc","buttonWrapper":"InsuranceUpload_buttonWrapper__u2Af-","dashedImageContainer":"InsuranceUpload_dashedImageContainer__ZlH9g"};